export default __webpack_public_path__ + "static/media/Pamungkas putih.d182fd76.png";